module.exports = __webpack_public_path__ + "static/media/preview_customers.7d4882c5.PNG";